import { render, staticRenderFns } from "./Vita.vue?vue&type=template&id=25b07d86&scoped=true&"
import script from "./Vita.vue?vue&type=script&lang=js&"
export * from "./Vita.vue?vue&type=script&lang=js&"
import style0 from "./Vita.vue?vue&type=style&index=0&id=25b07d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b07d86",
  null
  
)

export default component.exports